import React from "react";
import IconByName from "../IconByName";
import "./styles/FactList.css";

/**
 * Icon + label + value rows, ported from Elternverein's .ev-fact
 * (howFacts, bankFacts). Both come back from the API as
 * { label, value } — there's no title/text pair here, and no
 * iconName either; the icon is always the page's chosen default.
 *
 * <FactList facts={howFacts} defaultIcon="check" />
 */
export default function FactList({ facts = [], defaultIcon = "check", label }) {
  if (!facts.length) return null;

  return (
    <div className="rs-facts" aria-label={label}>
      {facts.map((fact, i) => (
        <div className="rs-fact" key={fact.id ?? i}>
          <span className="rs-fact__icon" aria-hidden="true">
            <IconByName name={fact.iconName || defaultIcon} size={20} />
          </span>
          <div className="rs-fact__text">
            <span>{fact.label}</span>
            <strong>{fact.value}</strong>
          </div>
        </div>
      ))}
    </div>
  );
}